module.exports = __webpack_public_path__ + "static/img/contact_back.a0aae81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/contact_back.png
// module id = 43pg
// module chunks = 4